import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { WatchlistResponse, WathclistUpdateObj } from "./watchlist.model";

@Injectable({
  providedIn: "root",
})
export class WatchlistService {
  apiEP: string = window.apiUrl;
  constructor(private http: HttpClient) {}

  saveWatchlist(jsonData): Observable<any> {
    return this.http.post(`${this.apiEP}/watcher/add_watcher/`, jsonData);
  }

  getWatchlists(): Observable<any> {
    return this.http.get(`${this.apiEP}/watcher/get_watchers_only/`);
  }

  getWatchlistsForTicker(ticker: string): Observable<WatchlistResponse> {
    return this.http.get<WatchlistResponse>(
      `${this.apiEP}/watcher/get_watchers_only/?edit_flag=false&ticker=${ticker}`,
    );
  }

  updateWatchlist(watchlist: WathclistUpdateObj) {
    return this.http.post(`${this.apiEP}/watcher/update_watcher/`, watchlist);
  }

  getSingleTickerSearch(query: string): Observable<any> {
    return this.http.get(
      `${this.apiEP}/api/n_tiksch?q=${encodeURIComponent(
        query,
      )}&ticker_filter=true&bbg_included=true`,
    );
  }

  getTickerSearchOnPaste(tickers: Array<string>): Observable<any> {
    const formData = new FormData();
    formData.append("tickers", tickers.toString());
    return this.http.post(`${this.apiEP}/watcher/get_valid_tickers/`, formData);
  }
}
